export function truncateWord(word: string, count: number) {
  if (word.length > count) {
    return `${word.substring(0, count)}...`;
  } else {
    return word;
  }
}

export function formatPrice(price: number, currencyCode: string = 'ARS', locale: string = 'es-AR') {
  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'code',
    minimumFractionDigits: 2,
  });

  return numberFormat.format(price / 100);
}

export function formatFileSize(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let index = 0;

  while (bytes >= 1024 && index < units.length - 1) {
    bytes /= 1024;
    index++;
  }

  return `${bytes.toFixed(2)} ${units[index]}`;
}

export function formatNumber(
  number: number,
  {
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
    locale,
  }: { minimumFractionDigits?: number; maximumFractionDigits?: number; locale?: string } = {},
): string {
  const resolvedLocale =
    locale ?? (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
  const numberFormat = new Intl.NumberFormat(resolvedLocale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  // Format the number
  return numberFormat.format(number);
}

export function formatCurrency(
  amount: number,
  {
    currency = '$',
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    locale,
  }: {
    currency?: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    locale?: string;
  } = {},
): string {
  const resolvedLocale =
    locale ?? (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
  const formatter = new Intl.NumberFormat(resolvedLocale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });
  return `${currency}${formatter.format(amount)}`;
}

export function truncateText(text: string, count: number) {
  const words = text.split(/\s+/);
  return words.slice(0, count).join(' ') + (words.length > count ? ' ...' : '');
}

export function stripHtml(html: string) {
  return html.replace(/<[^>]*>?/g, '');
}
